module.exports = __webpack_public_path__ + "static/media/DeleteOutlined.a9515c03.svg";